import React, { Component } from "react";
import { Subscribe } from "unstated";
import Slider from "react-slick";
import pdfjsLib from "pdfjs-dist/lib/pdf";
import { withTranslation } from "react-i18next";

import stringHelper from "../../utils/helpers/stringHelper";
import StateContainer from "../../state/StateContainer";
import Apartment from "./Apartment";
import ApartmentViewerBox from "./ApartmentViewerBox";
import CompareToggleView from "../../components/Buttons/CompareToggleView/CompareToggleView";
import CompareCanvas from "../../components/CompareCanvas/CompareCanvas";
import StarIcon from "../../components/Buttons/StarButton/StarButton";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Compare.css";

class Compare extends Component {
  constructor() {
    super();
    this.state = {
      firstApartmentViewer: null,
      secondApartmentViewer: null,
      firstApartmentViewerKey: null,
      secondApartmentViewerKey: null,
      isFirstContainerSceneInit: false,
      isSecondContainerSceneInit: false,


      pdfLeftScale: 1,
      pdfRightScale: 1,
      shownPdfRight: null,
      shownPdfLeft: null,
      leftCanvasScrollInterval: undefined,
      rightCanvasScrollInterval: undefined,
    };

    window.addEventListener("closeCompareWindow", (e) => {
      this.onWindowClose();
    });

    window.addEventListener("openCompareWindow", (e) => {
      this.renderPDFOnOpenWindow();
    });
  }

  /**
   * Executes when user close the Compare Window to reset pdf zoom to 1.
   */
  onWindowClose() {
    this.setState({
      pdfLeftScale: 1,
      pdfRightScale: 1,
    });
  }

  /**
   * Executes when user open Compare Window.
   * Checks if it should render pdf or not, if apartment is dragged to be displayed.
   */
  async renderPDFOnOpenWindow() {
    if (this.state.firstApartmentViewer !== null) {
      if (this.state.firstApartmentViewer.twoDimensionalPlanUrl !== "") {
        this.loadLeftPDFDocument(
          this.state.firstApartmentViewer.twoDimensionalPlanUrl
        );
      }
    }

    if (this.state.secondApartmentViewer !== null) {
      if (this.state.secondApartmentViewer.twoDimensionalPlanUrl !== "")
        this.loadRightPDFDocument(
          this.state.secondApartmentViewer.twoDimensionalPlanUrl
        );
    }
  }

  /**
   * Sets the apartment whose key is passed to an apartment viewer
   * depending on which selector is passed.
   * @param key Key of apartment being set
   * @param boxSelector Number which dictates to which viewer to set the apartment
   */
  async setApartmentViewed(key, boxSelector) {
    if (boxSelector === 1) {
      await this.setState({
        firstApartmentViewer: this.props.allApartments[key],
        firstApartmentViewerKey: key,
      });

      this.props.unstated.setState({
        leftApartmentStyles: {
          ...this.props.unstated.leftApartmentStyles,
          D2: { display: "block" },
          D3: { display: "none" }  
        }
      });

      if (this.state.firstApartmentViewer.twoDimensionalPlanUrl !== "")
        this.loadLeftPDFDocument(
          this.state.firstApartmentViewer.twoDimensionalPlanUrl
        );
    } else {
      await this.setState({
        secondApartmentViewer: this.props.allApartments[key],
        secondApartmentViewerKey: key,
      });

        this.props.unstated.setState({
          rightApartmentStyles: {
            ...this.props.unstated.rightApartmentStyles,
            D2: { display: "block" },
            D3: { display: "none" }
          },
        });


      if (this.state.secondApartmentViewer.twoDimensionalPlanUrl !== "")
        this.loadRightPDFDocument(
          this.state.secondApartmentViewer.twoDimensionalPlanUrl
        );
    }
  }

  /**
   * Handles the wheel event (zoom) for right canvas apartment container PDF.
   */
  async handleLeftPDFScroll(e) {
    e.preventDefault();
    if (this.state.leftCanvasScrollInterval !== undefined) return;
    let tempInterval = setTimeout(() => {
      let newScale = this.state.pdfLeftScale;
      if (e.deltaY > 0) {
        if (newScale <= 1) {
          clearInterval(tempInterval);
          this.setState({ leftCanvasScrollInterval: undefined });
          return;
        }
        newScale -= 0.25;
      } else if (e.deltaY < 0) {
        if (newScale >= 2) {
          clearInterval(tempInterval);
          this.setState({ leftCanvasScrollInterval: undefined });
          return;
        }
        newScale += 0.25;
      }
      this.setState({
        pdfLeftScale: newScale,
        leftCanvasScrollInterval: undefined,
      });
      this.displayLeftPage(this.state.shownPdfLeft, 1);

      clearInterval(tempInterval);
    }, 500);
    await this.setState({ leftCanvasScrollInterval: tempInterval });
  }
  /**
   * Handles the wheel event (zoom) for left canvas apartment container PDF.
   */
  async handleRightPDFScroll(e) {
    e.preventDefault();
    if (this.state.rightCanvasScrollInterval !== undefined) return;
    let tempInterval = setTimeout(() => {
      let newScale = this.state.pdfRightScale;
      if (e.deltaY > 0) {
        if (newScale <= 1) {
          clearInterval(tempInterval);
          this.setState({ rightCanvasScrollInterval: undefined });
          return;
        }
        newScale -= 0.25;
      } else if (e.deltaY < 0) {
        if (newScale >= 2) {
          clearInterval(tempInterval);
          this.setState({ rightCanvasScrollInterval: undefined });
          return;
        }
        newScale += 0.25;
      }
      this.setState({
        pdfRightScale: newScale,
        rightCanvasScrollInterval: undefined,
      });
      this.displayRightPage(this.state.shownPdfRight, 1);

      clearInterval(tempInterval);
    }, 500);
    await this.setState({ rightCanvasScrollInterval: tempInterval });
  }

  /**
   * Sets the wheel event to the canvas and renders the PDF onto canvas.
   * @param page PDF page we want to display.
   */
  renderLeftApartmentPDF(page) {
    let viewport = page.getViewport({ scale: this.state.pdfLeftScale });
    let canvas = document.getElementById("viewed-apt1");
    if (canvas === undefined) return;
    canvas.addEventListener("wheel", (e) => {
      this.handleLeftPDFScroll(e);
    });

    let context = canvas.getContext("2d");
    canvas.height = viewport.height;
    canvas.width = viewport.width;
    let renderContext = {
      canvasContext: context,
      viewport: viewport,
    };
    page.render(renderContext);
  }
  /**
   * Sets the wheel event to the canvas and renders the PDF onto canvas.
   * @param page PDF page we want to display.
   */
  renderRightApartmentPDF(page) {
    let viewport = page.getViewport({ scale: this.state.pdfRightScale });
    let canvas = document.getElementById("viewed-apt2");
    if (canvas === undefined) return;
    canvas.addEventListener("wheel", (e) => {
      this.handleRightPDFScroll(e);
    });
    let context = canvas.getContext("2d");
    canvas.height = viewport.height;
    canvas.width = viewport.width;
    let renderContext = {
      canvasContext: context,
      viewport: viewport,
    };
    page.render(renderContext);
  }
  /**
   * Fetches the PDF page.
   * @param pdf PDF file from which we want to load the page.
   * @param num number of page we want to load.
   */
  displayLeftPage(pdf, num) {
    pdf.getPage(num).then((page) => {
      this.renderLeftApartmentPDF(page);
    });
  }
  /**
   * Fetches the PDF page.
   * @param pdf PDF file from which we want to load the page.
   * @param num number of page we want to load.
   */
  displayRightPage(pdf, num) {
    pdf.getPage(num).then((page) => {
      this.renderRightApartmentPDF(page);
    });
  }

  /**
   * Fetches the PDF Document.
   * @param url Url of the pdf document we want to load.
   */
  loadLeftPDFDocument(url) {
    pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.js`;
    let pdfDoc = pdfjsLib.getDocument(url);
    pdfDoc.promise.then((pdf) => {
      this.displayLeftPage(pdf, 1);
      this.setState({ shownPdfLeft: pdf });
    });
  }

  /**
   * Fetches the PDF Document.
   * @param url Url of the pdf document we want to load.
   */
  loadRightPDFDocument(url) {
    pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.js`;
    let pdfDoc = pdfjsLib.getDocument(url);
    pdfDoc.promise.then((pdf) => {
      this.displayRightPage(pdf, 1);
      this.setState({ shownPdfRight: pdf });
    });
  }

  /**
   * Removes an apartment from a apartment viewer.
   * @param boxSelector Dictates which apartment viewer is being emptied
   */
  async removeViewedApartment(boxSelector) {
    if (boxSelector === 1) {
      if (this.state.firstApartmentViewer === null) return;
    } else {
      if (this.state.secondApartmentViewer === null) return;
    }

    if (boxSelector === 1) {
      let canvas = document.getElementById("viewed-apt1");
      if (canvas !== undefined) {
        canvas.removeEventListener("wheel", (e) => {
          this.handleLeftPDFScroll(e);
        });
      }
      let newStyle = { display: "none" };
      await this.setState({
        leftApartmentCanvas: null,
        firstApartmentViewer: null,
        firstApartmentViewerKey: null,
        leftApartmentStyles: newStyle,
      });

      this.props.unstated.setState({
        leftApartmentStyles: {
          ...this.props.unstated.leftApartmentStyles,
          D2: { display: "none" },
        },
      });

       this.props.unstated.setState({
         leftCompare3DContainerActive: false,
       });

    } else {
      let canvas = document.getElementById("viewed-apt2");
      if (canvas !== undefined) {
        canvas.removeEventListener("wheel", (e) => {
          this.handleRightPDFScroll(e);
        });
      }
      await this.setState({
        rightApartmentCanvas: null,
        secondApartmentViewer: null,
        secondApartmentViewerKey: null,
      });

      this.props.unstated.setState({
        rightApartmentStyles: {
          ...this.props.unstated.rightApartmentStyles,
          D2: { display: "none" },
        },
      });

       this.props.unstated.setState({
         rightCompare3DContainerActive: false,
       });

    }
  }

  /**
   * Dispatches an event to remove a favourite apartment.
   * @param key Key of apartment to be removed
   */
  removeFavourite(key) {
    let count = 0;
    if (this.state.firstApartmentViewer !== null) count++;
    if (this.state.secondApartmentViewer !== null) count++;

    let event = new CustomEvent("removeFavourite", {
      detail: {
        key,
        count: count,
      },
    });
    window.dispatchEvent(event);
  }


  render() {
    const { t } = this.props;

    return (
      <React.Fragment>
        {this.props.unstated.state.isCompareShown ? (
          <div id="compare-window" className="compare-container">
            <div className="compare__header">
              <div
                className="left__container"
                style={{
                  backgroundImage: `Url(${
                    this.props.unstated.state.jsonData.states[
                      this.props.unstated.state.currentState
                    ].rows[this.props.unstated.state.currentRow].highResUrls[
                      this.props.unstated.state.currentColumn
                    ]
                  })`,
                }}
              >
                <div className="button__container">
                  <button
                    className="back_button"
                    onClick={() => {
                      this.props.unstated.attachDragEvents();
                      this.props.unstated.toggleCompareShownOff();
                    }}
                  >
                    <img
                      src="/design/new-exports/large_left_arrow.png"
                      alt="left arrrow"
                    />
                    <span className="back__button--text">
                      {" "}
                      <span> {t("MODEL").toUpperCase()} </span> <strong>3D</strong>
                    </span>
                  </button>
                </div>
                <div
                  className="logo__container"
                  style={{
                    backgroundColor: stringHelper.removeAplhaFromColor(
                      this.props.unstated.state.menuColor
                    ),
                  }}
                >
                  <div
                    className="logo"
                    style={{
                      backgroundImage: `Url(${
                        this.props.unstated.state.projectLogo
                          ? this.props.unstated.state.projectLogo
                          : ""
                      })`,
                    }}
                  />
                  <div 
                    className="star_icon__container"
                    style={{ backgroundColor: this.props.unstated.state.menuColorSecondary}}
                    >
                    <StarIcon isStatic={true} />
                  </div>
                </div>
              </div>

              <div className="right__container">
                {this.props.clientLogo ? (
                  <img
                    className="image"
                    alt="client logo"
                    src={this.props.clientLogo}
                  ></img>
                ) : null}
                <div
                  id="apartment-container"
                  style={{
                    width: "85%",
                    height: "50%",
                    marginLeft: !this.props.clientLogo ? "15%" : "0px",
                  }}
                >
                  <Slider
                    {...this.props.unstated.state.carouselCompareSettings}
                  >
                    {this.props.unstated.state.favouriteApartmentsDetails
                      ? this.props.unstated.state.favouriteApartmentsDetails
                          .filter((apartment) => {
                            return (
                              apartment.key !==
                                this.state.firstApartmentViewerKey &&
                              apartment.key !==
                                this.state.secondApartmentViewerKey
                            );
                          })
                          .map((apartment) => (
                            <Apartment
                              removeFavourite={this.removeFavourite.bind(this)}
                              id={apartment.key}
                              key={apartment.key}
                              price={apartment.price}
                              type={apartment.type}
                              name={apartment.name}
                              thumbnail={apartment.thumbnail}
                              quadrature={apartment.quadrature}
                            ></Apartment>
                          ))
                      : null}
                  </Slider>
                </div>
              </div>
            </div>
            {/* ======================= Draging section ======================= */}
            <div className="dragging__container">
              <div className="apartment__box--border">
                {/* Compared Apartment 1 */}
                <ApartmentViewerBox
                  style={this.props.unstated.state.leftApartmentStyles.D2}
                  isMouseOver={this.state.mouseOverFirst}
                  apartmentInfo={this.state.firstApartmentViewer}
                  isSet={!!this.state.firstApartmentViewer}
                  number={1}
                  setApartmentViewed={this.setApartmentViewed.bind(this)}
                  removeViewedApartment={this.removeViewedApartment.bind(this)}
                />

                {this.state.firstApartmentViewer &&
                  this.props.unstated.state.leftCompare3DContainerActive && (
                    <CompareCanvas
                      containerType="leftContainer"
                      image3dUrl={
                        this.state.firstApartmentViewer.highResUrls[0]
                      }
                    />
                  )}
                {this.state.firstApartmentViewer && (
                  <CompareToggleView activeContainer="leftContainer" />
                )}

                {this.state.firstApartmentViewer === null ? (
                  <span className="drag_disclaimer">
                    {t("DRAG_YOUR_ACCOMMODATION").toUpperCase()}
                  </span>
                ) : null}
              </div>
              <div className="apartment__box--border no-border">
                {/* Compared Apartment 2 */}
                <ApartmentViewerBox
                  style={this.props.unstated.state.rightApartmentStyles.D2}
                  isMouseOver={this.state.mouseOverSecond}
                  apartmentInfo={this.state.secondApartmentViewer}
                  isSet={!!this.state.secondApartmentViewer}
                  secondCompareContainerActiveType
                  number={2}
                  setApartmentViewed={this.setApartmentViewed.bind(this)}
                  removeViewedApartment={this.removeViewedApartment.bind(this)}
                />
                {this.state.secondApartmentViewer &&
                  this.props.unstated.state.rightCompare3DContainerActive && (
                    <CompareCanvas
                      containerType="rightContainer"
                      image3dUrl={
                        this.state.secondApartmentViewer.highResUrls[0]
                      }
                    />
                  )}
                {this.state.secondApartmentViewer && (
                  <CompareToggleView activeContainer="rightContainer" />
                )}
                {this.state.secondApartmentViewer === null ? (
                  <span className="drag_disclaimer">
                    {t("DRAG_YOUR_ACCOMMODATION").toUpperCase()}
                  </span>
                ) : null}
              </div>
            </div>
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

const CompareWithUnstated = (props) => {
  return (
  <Subscribe to={[StateContainer]}>
    {unstated => ( <Compare {...props} unstated={unstated} /> )}
  </Subscribe>
  )
}

export default withTranslation()(CompareWithUnstated);
